module.exports = __webpack_public_path__ + "media/components/icons/SVG/poligono-2d8b5e9dd54f26c4f376b9d12678cadf.svg";